export default __webpack_public_path__ + "static/media/logo.8a3a8957.png";